import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export function Toast({ message, type = 'info', duration = 5000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(), 300); // Wait for fade out animation before removing
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getToastClasses = () => {
    const baseClasses = "fixed bottom-4 right-4 p-4 rounded-lg shadow-lg flex items-center space-x-3 transition-all duration-300";
    const visibilityClasses = isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2";
    
    let typeClasses = "bg-blue-50 text-blue-800 border border-blue-200";
    if (type === 'success') typeClasses = "bg-green-50 text-green-800 border border-green-200";
    if (type === 'error') typeClasses = "bg-red-50 text-red-800 border border-red-200";
    if (type === 'warning') typeClasses = "bg-yellow-50 text-yellow-800 border border-yellow-200";

    return `${baseClasses} ${visibilityClasses} ${typeClasses}`;
  };

  return (
    <div className={getToastClasses()}>
      <div>{message}</div>
      <button onClick={() => setIsVisible(false)} className="ml-auto text-gray-500 hover:text-gray-700">
        <X size={16} />
      </button>
    </div>
  );
}

export function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="fixed bottom-0 right-0 p-4 space-y-3 z-50">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}